import React, { useState, useEffect } from 'react';
import toast, { Toaster } from 'react-hot-toast';

const ManageStats = () => {
  const [stats, setStats] = useState<any>({});
  const backendUrl = "https://www.sevaafoundation.com/seva-backend";
//   const backendUrl = "http://localhost/seva-backend";
  const token = localStorage.getItem("sevaa_admin_token");

  useEffect(() => {
    fetch(`${backendUrl}/api/stats/get_stats.php`)
      .then(res => res.json())
      .then(data => { if(data.success) setStats(data.stats); });
  }, []);

  const handleUpdate = async (e: React.FormEvent) => {
    e.preventDefault();
    const loadingToast = toast.loading("Updating stats...");

    try {
      const response = await fetch(`${backendUrl}/api/stats/update_stats.php`, {
        method: "POST",
        headers: { 
          "Content-Type": "application/json",
          "Authorization": `Bearer ${token}` 
        },
        body: JSON.stringify(stats)
      });
      const data = await response.json();
      if (data.success) toast.success("Stats updated!", { id: loadingToast });
    } catch (err) {
      toast.error("Update failed", { id: loadingToast });
    }
  };

  return (
    <div className="p-8">
      <Toaster />
      <h1 className="text-3xl font-bold mb-6">Manage Website Stats</h1>
      <form onSubmit={handleUpdate} className="grid grid-cols-2 gap-6 bg-white p-6 rounded-xl shadow">
        {Object.keys(stats).map((key) => (
          <div key={key}>
            <label className="block text-xs font-bold text-slate-500 uppercase mb-1">{key.replace('_', ' ')}</label>
            <input 
              type="text" 
              value={stats[key]} 
              onChange={e => setStats({...stats, [key]: e.target.value})}
              className="w-full px-4 py-2 border rounded outline-none focus:border-orange-500"
            />
          </div>
        ))}
        <button type="submit" className="col-span-2 bg-slate-900 text-white py-3 rounded-lg font-bold hover:bg-slate-800">Save Changes</button>
      </form>
    </div>
  );
};

export default ManageStats;